import { render, staticRenderFns } from "./Building.vue?vue&type=template&id=ffc0df1c"
import script from "./Building.vue?vue&type=script&lang=ts"
export * from "./Building.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports